
// Replace , with . for javascrip understand that its a number to parseFloat

export function parseFloatCommaToDot(number: string) {
	return parseFloat(number.replace(',', '.'));
}
